import { Box, Stack } from '@mui/material'
import DragDrop from './DragDrop'
import Manual from './mapeo/Manual'
import MapeoHeader from './mapeo/MapeoHeader'
import ShowFolders from './mapeo/ShowFolders'

const CategorizationPanel = ({
  actualYearId,
  carbonInstances,
  center,
  etapa,
  exclusionAreas,
  fileType,
  handleActualYearId,
  handleCarbonInstances,
  handleDownload,
  handleDrawingType,
  handleEtapa,
  handleExclusionAreas,
  handleExclusionAreasSaved,
  handleFileType,
  handleIncludeProjectArea,
  handleIncludeSoilInfo,
  handleMappingSaved,
  handleMapUpdate,
  handleMonitoringSites,
  handleOtherPolygons,
  handleOtherSites,
  handlePaddocks,
  handlePerimeter,
  handlePerimeterSaved,
  handleSamplingAreas,
  handleOtherLayersSaved,
  handleSamplingAreasSaved,
  handleSaved,
  handleUnassigned,
  handleUnassignedPoints,
  includeProjectArea,
  includeSoilInfo,
  mapUpdate,
  monitoringSites,
  otherPolygons,
  otherSites,
  paddocks,
  perimeter,
  samplingAreas,
  saved,
  unassigned,
  unassignedPoints,
}) => {
  return (
    <Stack
      sx={{
        width: '100%',
      }}
    >
      {etapa === 'inicial' || etapa === 'inicialManual' || etapa === 'drawingStarted' ? (
        <MapeoHeader />
      ) : null}
      {/*
        TODO: Hidden until fixed
      {etapa === 'inicial' ? <ManualMapeoHeader handleEtapa={handleEtapa} /> : null} */}
      <Box
        sx={{
          width: '100%',
        }}
      >
        {etapa === 'inicial' || etapa === 'fileUploaded' ? (
          <Box m={2}>
            <DragDrop
              handleEtapa={handleEtapa}
              handleExclusionAreas={handleExclusionAreas}
              handleMonitoringSites={handleMonitoringSites}
              handleOtherPolygons={handleOtherPolygons}
              handleOtherSites={handleOtherSites}
              handlePaddocks={handlePaddocks}
              handlePerimeter={handlePerimeter}
              handleSamplingAreas={handleSamplingAreas}
              handleUnassigned={handleUnassigned}
              handleUnassignedPoints={handleUnassignedPoints}
            />
          </Box>
        ) : null}
        {etapa === 'inicialManual' || etapa === 'drawingStarted' ? (
          <Manual
            center={center}
            etapa={etapa}
            handleDrawingType={handleDrawingType}
            handleEtapa={handleEtapa}
            handlePerimeter={handlePerimeter}
            handlePerimeterSaved={handlePerimeterSaved}
            perimeter={perimeter}
          />
        ) : null}
        {etapa === 'showingFoldersManual' ||
        etapa === 'showingFoldersArchivo' ||
        etapa === 'showingFoldersApi' ? (
          <ShowFolders
            actualYearId={actualYearId}
            carbonInstances={carbonInstances}
            center={center}
            etapa={etapa}
            exclusionAreas={exclusionAreas}
            fileType={fileType}
            handleActualYearId={handleActualYearId}
            handleCarbonInstances={handleCarbonInstances}
            handleDownload={handleDownload}
            handleEtapa={handleEtapa}
            handleExclusionAreas={handleExclusionAreas}
            handleExclusionAreasSaved={handleExclusionAreasSaved}
            handleFileType={handleFileType}
            handleIncludeProjectArea={handleIncludeProjectArea}
            handleIncludeSoilInfo={handleIncludeSoilInfo}
            handleMappingSaved={handleMappingSaved}
            handleMapUpdate={handleMapUpdate}
            handleMonitoringSites={handleMonitoringSites}
            handleOtherLayersSaved={handleOtherLayersSaved}
            handleOtherPolygons={handleOtherPolygons}
            handleOtherSites={handleOtherSites}
            handlePaddocks={handlePaddocks}
            handlePerimeter={handlePerimeter}
            handleSamplingAreas={handleSamplingAreas}
            handleSamplingAreasSaved={handleSamplingAreasSaved}
            handleSaved={handleSaved}
            handleUnassigned={handleUnassigned}
            handleUnassignedPoints={handleUnassignedPoints}
            includeProjectArea={includeProjectArea}
            includeSoilInfo={includeSoilInfo}
            mapUpdate={mapUpdate}
            monitoringSites={monitoringSites}
            otherPolygons={otherPolygons}
            otherSites={otherSites}
            paddocks={paddocks}
            perimeter={perimeter}
            samplingAreas={samplingAreas}
            saved={saved}
            unassigned={unassigned}
            unassignedPoints={unassignedPoints}
          />
        ) : null}
      </Box>
    </Stack>
  )
}

export default CategorizationPanel
